<div class="custom-tables table-responsive">
    <table class="table table-centered">
        <thead>
            <tr>
                <th>{{ 'Common.Name' | translate }}</th>
                <th>{{ 'Common.Phone' | translate }}</th>
                <th>{{ 'Common.ClientType' | translate }}</th>
                <th>{{ 'Common.Parent' | translate }}</th>
                <th>{{ 'Common.Balance' | translate }}</th>
                <th>{{ 'Common.CommercialRegister' | translate }}</th>
                <th>{{ 'Common.TaxNumber' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>{{ data.User.UserFullName }}</td>
                <td>{{ data.User.UserName }}</td>
                <td>{{ customersType[data.UserType] }}</td>
                <td>{{ data.ParentId ? data.Parent.User.UserFullName : '-' }}</td>
                <td>{{ data.User ? data.User.Balance : '-' }}</td>
                <td>{{ data.CommercialRecord ? data.CommercialRecord : '-' }}</td>
                <td>{{ data.TaxNumber ? data.TaxNumber : '-' }}</td>
            </tr>
        </tbody>
    </table>
</div>